import { render, staticRenderFns } from "./FormGrupo.vue?vue&type=template&id=5014e5b8"
import script from "./FormGrupo.vue?vue&type=script&lang=js"
export * from "./FormGrupo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports